import { Box } from "@mui/material";
import { format } from "date-fns";
import { epochToDate } from "../../../../app/common";
import i18n from "../../../../i18n";

interface Props {
  start: number;
  backgroundColor?: string;
}

const DayOfWeekDate = ({ start, backgroundColor }: Props) => {
  const lang = i18n?.language;

  // Get get from epochtime
  const startDate = epochToDate(start);
  // Convert date to correct format
  const newFormattedDate = format(new Date(startDate), "dd.MM.yyyy");

  // Set options for day of week locale
  const options: Intl.DateTimeFormatOptions = { weekday: "long" };
  // Get day of week from date

  const dayOfWeek = new Date(startDate).toLocaleDateString(
    lang || "fi-FI",
    options,
  );
  // Capitalize first letter
  const capitalizedDayOfWeek =
    dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderBottom: "none",
      }}
    >
      <Box
        sx={{
          marginRight: "10px",
          color: "#FFFFFF",
          backgroundColor: backgroundColor
            ? backgroundColor
            : "rgba(0, 0, 0, 0.38)",
          padding: "5px",
          borderRadius: "10px",
          fontSize: "16px",
          lineHeight: "20px",
          fontWeight: "600",
        }}
      >
        {newFormattedDate.split(".")[0]}
      </Box>
      <Box sx={{ whiteSpace: "nowrap", fontSize: "16px" }}>
        {`${capitalizedDayOfWeek} ${newFormattedDate}`}
      </Box>
    </Box>
  );
};

export default DayOfWeekDate;
